<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';

const props = defineProps({
  context: { type: Object, default: () => ({}) },
  show: { type: Boolean, default: false },
});
const emit = defineEmits(['close']);
const { t } = useI18n();
const participantName = computed(
  () =>
    props.context.participant?.name || t('SALES_PARTIES.REVIEW.UNKNOWN_PARTY')
);
const kindLabel = computed(() => {
  if (props.context.relationType === 'representante')
    return t('SALES_PARTIES.REVIEW.REPRESENTATIVE');
  return (props.context.section || '').endsWith('_pj')
    ? t('SALES_PARTIES.COMMON.LEGAL_PEOPLE')
    : t('SALES_PARTIES.COMMON.PHYSICAL_PEOPLE');
});
</script>

<template>
  <LaisModal
    :show="show"
    :title="t('SALES_PARTIES.REVIEW.TITLE')"
    max-width-class="max-w-[760px]"
    @close="emit('close')"
  >
    <div class="grid gap-5">
      <header class="flex flex-wrap items-center gap-2">
        <h2 class="font-redHatDisplay text-xl font-bold text-lais-text">
          {{ participantName }}
        </h2>
        <span
          class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-muted"
        >
          {{ kindLabel }}
        </span>
        <span
          v-if="context.parentParty"
          class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-muted"
        >
          {{ context.parentParty.name }}
        </span>
      </header>

      <section class="grid gap-2">
        <h3
          class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('SALES_PARTIES.REVIEW.CHECKS') }}
        </h3>
        <ul
          class="grid gap-2 rounded-lais-sm bg-lais-bg-soft p-4 text-sm text-lais-text-body"
        >
          <li v-for="(check, index) in context.checks" :key="check.id || index">
            {{ check.name || check.nome || check }}
          </li>
          <li v-if="!context.checks.length">
            {{ t('SALES_PARTIES.REVIEW.EMPTY') }}
          </li>
        </ul>
      </section>

      <section class="grid gap-2">
        <h3
          class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('SALES_PARTIES.REVIEW.OBSERVATION') }}
        </h3>
        <p
          class="whitespace-pre-wrap rounded-lais-sm border border-lais-border-soft p-4 text-sm text-lais-text-body"
        >
          {{ context.observation || t('SALES_PARTIES.REVIEW.EMPTY') }}
        </p>
      </section>
    </div>
  </LaisModal>
</template>
